import DepositView from 'src/sections/overview/deposit/view/deposit-view';

export default function Deposit() {
  return <DepositView />;
}
